import httpService from '@/services/httpService'

export const types = {
  ADD_WEB_PROPERTIES: 'web-property/ADD_WEB_PROPERTIES',
  ADD_TYPES_OPTIONS: 'web-property/ADD_TYPES_OPTIONS'
}
const emptyData = {
  webProperties: [],
  typesOptions: []
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_WEB_PROPERTIES]: function (state, webProperties) {
    state.webProperties = webProperties
  },
  [types.ADD_TYPES_OPTIONS]: function (state, typesOptions) {
    state.typesOptions = typesOptions
  }
}

const actions = {
  getWebProperties: async function ({ commit }, { clientId, ...params }) {
    const response = await httpService.get(`/web_property/data/${clientId}`, { params })
    if (!response) {
      return
    }
    commit(types.ADD_WEB_PROPERTIES, response.data.web_properties)
    commit(types.ADD_TYPES_OPTIONS, response.data.types)
    return response
  },
  createNewWebProperty: async function ({ commit }, { clientId, ...params }) {
    const response = await httpService.post(`/web_property/create/${clientId}`, params, { successMessage: 'Web Property created successfully', raiseError: true })
    if (!response) {
      return
    }
    return response
  },
  updateWebProperty: async function ({ commit }, { webPropertyId, ...params }) {
    const response = await httpService.patch(`/web_property/update/${webPropertyId}`, params, { successMessage: 'Web Property updated successfully', raiseError: true })
    if (!response) {
      return
    }
    return response
  },
  removeWebProperty: async function ({ commit }, { webPropertyId }) {
    const response = await httpService.delete(`/web_property/remove/${webPropertyId}`, { successMessage: 'Web Property removed successfully', raiseError: true } )
    if (!response) {
      return
    }
    return response
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
